import { render, staticRenderFns } from "./LoginActionSuccessPage.vue?vue&type=template&id=1f10adb4&"
import script from "./LoginActionSuccessPage.vue?vue&type=script&lang=ts&"
export * from "./LoginActionSuccessPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f10adb4')) {
      api.createRecord('1f10adb4', component.options)
    } else {
      api.reload('1f10adb4', component.options)
    }
    module.hot.accept("./LoginActionSuccessPage.vue?vue&type=template&id=1f10adb4&", function () {
      api.rerender('1f10adb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/LoginActionSuccessPage.vue"
export default component.exports